import { render, staticRenderFns } from "./CampanhaMetas.vue?vue&type=template&id=255ef8f0&scoped=true"
import script from "./CampanhaMetas.vue?vue&type=script&lang=js"
export * from "./CampanhaMetas.vue?vue&type=script&lang=js"
import style0 from "./CampanhaMetas.vue?vue&type=style&index=0&id=255ef8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ef8f0",
  null
  
)

export default component.exports